<main class="relatorio">
  <header class="topo">
    <div class="topo__titulo">
      <a class="migalha" routerLink="/admin/mia-gestor/leads"><i class="fas fa-chevron-left" aria-hidden="true"></i> Leads</a>
      <h1><span class="topo__icone"><i class="fas fa-chart-pie" aria-hidden="true"></i></span>Relatório de leads</h1>
      <p>De onde vêm os leads e até onde cada origem chega no funil. Clique numa linha para filtrar a tela toda por ela.</p>
    </div>
  </header>

  <!-- busca, período e filtros: valem para todas as abas -->
  <section class="barra" aria-label="Filtros do relatório">
    <label class="busca">
      <i class="fas fa-search" aria-hidden="true"></i>
      <input type="search" [(ngModel)]="busca" (ngModelChange)="recalcule()" placeholder="Buscar nome, empresa, telefone…" aria-label="Buscar lead">
    </label>
    <div class="periodo" role="group" aria-label="Período">
      <button type="button" *ngFor="let p of periodos" [class.ativo]="dias === p.dias" [attr.aria-pressed]="dias === p.dias"
              (click)="mudePeriodo(p.dias)" [disabled]="carregando">{{ p.rotulo }}</button>
    </div>
    <button type="button" class="botao-filtros" [class.ativo]="filtrosAbertos || ativos.length" (click)="filtrosAbertos = !filtrosAbertos"
            [attr.aria-expanded]="filtrosAbertos" aria-controls="painel-filtros">
      <i class="fas fa-filter" aria-hidden="true"></i> Filtros
      <span class="contador" *ngIf="ativos.length">{{ ativos.length }}</span>
    </button>
    <span class="barra__total num">
      <i class="fas fa-circle-notch girando" *ngIf="carregando" aria-hidden="true"></i>
      {{ leads.length === todos.length ? leads.length + ' lead(s)' : leads.length + ' de ' + todos.length + ' leads' }}
    </span>
  </section>

  <section id="painel-filtros" class="filtros" *ngIf="filtrosAbertos">
    <label *ngFor="let f of filtros" class="filtro" [class.filtro--ativo]="escolhidos[f.chave]">
      <span>{{ f.rotulo }}</span>
      <select [ngModel]="escolhidos[f.chave] || ''" (ngModelChange)="escolha(f.chave, $event)">
        <option value="">Todos</option>
        <option *ngFor="let o of opcoes[f.chave]" [value]="o">{{ o }}</option>
      </select>
    </label>
  </section>

  <div class="ativos" *ngIf="ativos.length || busca">
    <span class="ativos__rotulo">Filtrando por</span>
    <button type="button" class="pilula" *ngFor="let a of ativos" (click)="escolha(a.chave, '')" [attr.aria-label]="'Tirar filtro ' + a.rotulo">
      {{ a.rotulo }}: <b>{{ a.valor }}</b> <i class="fas fa-times" aria-hidden="true"></i>
    </button>
    <button type="button" class="pilula" *ngIf="busca" (click)="busca = ''; recalcule()">busca: <b>{{ busca }}</b> <i class="fas fa-times" aria-hidden="true"></i></button>
    <button type="button" class="limpar" (click)="limpe()">Limpar filtros</button>
  </div>

  <p class="faixa faixa--erro" role="alert" *ngIf="erro"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erro }}</p>

  <nav class="abas" role="tablist" aria-label="Seções do relatório">
    <button type="button" role="tab" [class.ativa]="aba === 'geral'" [attr.aria-selected]="aba === 'geral'" (click)="aba = 'geral'">Visão geral</button>
    <button type="button" role="tab" [class.ativa]="aba === 'origens'" [attr.aria-selected]="aba === 'origens'" (click)="aba = 'origens'">Origens e campanhas</button>
    <button type="button" role="tab" [class.ativa]="aba === 'perfil'" [attr.aria-selected]="aba === 'perfil'" (click)="aba = 'perfil'">Perfil</button>
    <button type="button" role="tab" [class.ativa]="aba === 'leads'" [attr.aria-selected]="aba === 'leads'" (click)="aba = 'leads'">Leads <span class="num">{{ leads.length }}</span></button>
  </nav>

  <p class="vazio" *ngIf="!carregando && !erro && !leads.length">
    {{ todos.length ? 'Nenhum lead com esses filtros.' : 'Nenhum lead chegou neste período.' }}
  </p>

  <!-- ===================== VISÃO GERAL ===================== -->
  <ng-container *ngIf="aba === 'geral' && leads.length">
    <div class="kpis">
      <div class="kpi">
        <span class="kpi__icone" style="background: linear-gradient(135deg, #4f7fe0, #2d5cb8)"><i class="fas fa-inbox" style="color: white" aria-hidden="true"></i></span>
        <div><strong class="num">{{ leads.length }}</strong><span>leads</span><small>{{ hoje }} hoje</small></div>
      </div>
      <div class="kpi">
        <span class="kpi__icone" style="background: linear-gradient(135deg, #2bb07f, #16875a)"><i class="fas fa-laptop" style="color: white" aria-hidden="true"></i></span>
        <div><strong class="num">{{ comComputador }}</strong><span>com computador</span>
          <small><b class="vermelho num">{{ semComputador }}</b> sem · o sistema exige computador</small></div>
      </div>
      <div class="kpi">
        <span class="kpi__icone" style="background: linear-gradient(135deg, #22a5b3, #0f7f8c)"><i class="fas fa-comment-dots" style="color: white" aria-hidden="true"></i></span>
        <div><strong class="num">{{ funil[1]?.total }}</strong><span>conversaram</span>
          <small>de cada 10 leads, ≈{{ (funil[1]?.pct / 10) | number:'1.0-0' }} escrevem</small></div>
      </div>
      <div class="kpi">
        <span class="kpi__icone" style="background: linear-gradient(135deg, #9166e0, #6d3fc0)"><i class="fas fa-flask" style="color: white" aria-hidden="true"></i></span>
        <div><strong class="num">{{ funil[2]?.total }}</strong><span>criaram teste</span><small>{{ funil[3]?.total }} entraram no painel</small></div>
      </div>
      <div class="kpi">
        <span class="kpi__icone" style="background: linear-gradient(135deg, #f0a13a, #d97706)"><i class="fas fa-handshake" style="color: white" aria-hidden="true"></i></span>
        <div><strong class="num">{{ funil[4]?.total }}</strong><span>clientes</span><small>{{ funil[4]?.pct }}% dos leads</small></div>
      </div>
    </div>

    <section class="cartao">
      <h2>Funil do período</h2>
      <p class="nota">Cada lead conta até a etapa mais longe que alcançou. Porcentagem sobre o total de leads; nas emendas, a passagem de uma etapa para a outra.</p>
      <div class="funil">
        <div class="funil__etapas">
          <div class="funil__etapa" *ngFor="let e of funil; let i = index" [style.--cor]="e.cor">
            <span class="funil__rotulo">{{ e.rotulo }}</span>
            <strong class="num">{{ e.total }}</strong>
            <small class="num">{{ e.pct }}%</small>
            <span class="funil__passagem num" *ngIf="e.passagem !== null" [attr.title]="'Passagem de ' + funil[i - 1].rotulo + ' para ' + e.rotulo">{{ e.passagem }}%</span>
          </div>
        </div>
        <svg class="funil__onda" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="onda-leads" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stop-color="#2d5cb8"/><stop offset="30%" stop-color="#0f7f8c"/><stop offset="55%" stop-color="#6d3fc0"/>
              <stop offset="75%" stop-color="#4a2ba0"/><stop offset="100%" stop-color="#16875a"/>
            </linearGradient>
          </defs>
          <path [attr.d]="ondaCaminho" fill="url(#onda-leads)" opacity=".18"/>
          <path [attr.d]="ondaLinha" fill="none" stroke="url(#onda-leads)" stroke-width="1.2" vector-effect="non-scaling-stroke"/>
        </svg>
      </div>
    </section>

    <section class="cartao">
      <h2>Quem traz lead que fecha</h2>
      <p class="nota">Por fonte: quantos leads e quanto de cada uma chega ao teste e vira cliente. Clique para filtrar.</p>
      <ng-container *ngTemplateOutlet="tabelaFunil; context: {grupos: porFonte, chave: 'fonte'}"></ng-container>
    </section>
  </ng-container>

  <!-- ===================== ORIGENS E CAMPANHAS ===================== -->
  <ng-container *ngIf="aba === 'origens' && leads.length">
    <div class="duas">
      <section class="cartao">
        <h2>Pago × orgânico</h2>
        <ng-container *ngTemplateOutlet="barras; context: {grupos: porTipo, chave: 'tipo'}"></ng-container>
      </section>
      <section class="cartao">
        <h2>Site de entrada</h2>
        <ng-container *ngTemplateOutlet="barras; context: {grupos: porSite, chave: 'site'}"></ng-container>
      </section>
    </div>

    <section class="cartao">
      <h2>Leads por {{ serieMensal ? 'mês' : 'dia' }}</h2>
      <div class="legenda">
        <span *ngFor="let t of ['Pago', 'Orgânico', 'Referral', 'Manual']"><i [style.background]="corDoTipo[t]"></i>{{ t }}</span>
      </div>
      <div class="serie" [class.serie--densa]="serie.length > 31">
        <div class="serie__coluna" *ngFor="let s of serie; trackBy: porRotulo" [attr.title]="s.dica">
          <div class="serie__pilha" [style.height.%]="s.total * 100 / serieMaximo">
            <span *ngFor="let p of s.partes" [style.flex-grow]="p.total" [style.background]="corDoTipo[p.tipo]"></span>
          </div>
          <small class="num">{{ s.rotulo }}</small>
        </div>
      </div>
    </section>

    <section class="cartao">
      <h2>Campanhas</h2>
      <p class="nota">Pelo <code>utm_campaign</code> da URL do formulário ou, no Google Ads sem UTM, pelo número da campanha.
        {{ semCampanha }} lead(s) sem campanha ficam de fora.</p>
      <ng-container *ngIf="porCampanha.length; else semCampanha">
        <ng-container *ngTemplateOutlet="tabelaFunil; context: {grupos: porCampanha, chave: 'campanha'}"></ng-container>
      </ng-container>
      <ng-template #semCampanha><p class="vazio vazio--dentro">Nenhum lead do período veio com campanha na URL.</p></ng-template>
    </section>
  </ng-container>

  <!-- ===================== PERFIL ===================== -->
  <ng-container *ngIf="aba === 'perfil' && leads.length">
    <div class="duas">
      <section class="cartao">
        <h2>Tem computador?</h2>
        <div class="destaque">
          <ng-container *ngTemplateOutlet="barras; context: {grupos: porComputador, chave: 'computador'}"></ng-container>
          <div class="destaque__numero">
            <strong class="num">{{ pct(comComputador, comComputador + semComputador) }}%</strong>
            <small>de quem respondeu tem</small>
          </div>
        </div>
      </section>
      <section class="cartao">
        <h2>Dispositivo</h2>
        <ng-container *ngTemplateOutlet="barras; context: {grupos: porDispositivo, chave: 'dispositivo'}"></ng-container>
      </section>
    </div>

    <section class="cartao">
      <h2>Hora em que preenchem</h2>
      <p class="nota" *ngIf="comHora < leads.length">
        {{ comHora }} de {{ leads.length }} leads têm o horário do formulário; os colados antes desta versão só têm a hora da colagem e ficam de fora.
      </p>
      <ng-container *ngIf="comHora; else semHora">
        <div class="horas">
          <div class="horas__coluna" *ngFor="let n of porHora; let h = index" [attr.title]="h + 'h: ' + n + ' lead(s)'">
            <span [style.height.%]="n ? n * 100 / horaMaximo : 0" [class.melhor]="h === melhorHora" [class.zero]="!n"></span>
            <small *ngIf="h % 3 === 0">{{ h }}h</small>
          </div>
        </div>
        <div class="turnos">
          <button type="button" class="turno" *ngFor="let t of porTurno" [style.--cor]="t.cor"
                  [class.turno--ativo]="escolhidos.turno === t.rotulo" (click)="alterne('turno', t.rotulo)">
            <i class="fas {{ t.icone }}" aria-hidden="true"></i>
            <span class="turno__nome">{{ t.rotulo }} <small>{{ t.faixa }}</small></span>
            <strong class="num">{{ t.total }} <small>{{ t.pct }}%</small></strong>
            <span class="trilho"><span [style.width.%]="t.pct"></span></span>
          </button>
        </div>
      </ng-container>
      <ng-template #semHora><p class="vazio vazio--dentro">Ainda não há lead com horário do formulário neste filtro.</p></ng-template>
    </section>

    <div class="duas">
      <section class="cartao">
        <h2>Estado (pelo DDD)</h2>
        <ng-container *ngTemplateOutlet="barras; context: {grupos: principaisEstados, chave: 'uf'}"></ng-container>
        <p class="nota" *ngIf="porEstado.length > 12">+ {{ porEstado.length - 12 }} estado(s) com menos leads.</p>
      </section>
      <section class="cartao">
        <h2>Por que perdemos</h2>
        <ng-container *ngIf="porMotivo.length; else semPerda">
          <ng-container *ngTemplateOutlet="barras; context: {grupos: porMotivo, chave: null}"></ng-container>
        </ng-container>
        <ng-template #semPerda><p class="vazio vazio--dentro">Nenhum lead marcado como Perdido neste filtro.</p></ng-template>
      </section>
    </div>
  </ng-container>

  <!-- ===================== LEADS ===================== -->
  <section class="cartao cartao--lista" *ngIf="aba === 'leads' && leads.length">
    <table class="lista">
      <thead>
        <tr><th>Chegou</th><th>Lead</th><th>Origem</th><th>Perfil</th><th>Etapa</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let l of leads; trackBy: porId">
          <td class="num">{{ dataCurta(l.chegouEm) }}<small>{{ l.chegouEm.slice(11) }}<ng-container *ngIf="!l.horaDoFormulario"> · colagem</ng-container></small></td>
          <td><strong>{{ l.nome || 'Sem nome' }}</strong><small>{{ l.empresa || 'Empresa não informada' }} · <span class="num">{{ telefoneFormatado(l.telefone) }}</span></small></td>
          <td><span class="etiqueta" [style.--cor]="corDaFonte(l.fonte)">{{ l.fonte }}</span><small>{{ l.campanha || l.site || '' }}</small></td>
          <td>{{ l.uf || '—' }} · {{ l.dispositivo || 'dispositivo ?' }}
            <small [class.verde]="l.temComputador === true" [class.vermelho]="l.temComputador === false">
              {{ l.temComputador === null ? 'computador ?' : l.temComputador ? 'com computador' : 'sem computador' }}</small></td>
          <td><span class="etapa etapa--{{ l.etapa | lowercase }}">{{ rotuloEtapa(l.etapa) }}</span>
            <small *ngIf="l.motivoPerda">{{ l.motivoPerda }}</small></td>
        </tr>
      </tbody>
    </table>
  </section>
</main>

<!-- barras horizontais: rótulo, barra proporcional ao maior, total e % -->
<ng-template #barras let-grupos="grupos" let-chave="chave">
  <ul class="barras">
    <li *ngFor="let g of grupos; trackBy: porRotulo">
      <button type="button" [disabled]="!chave" [class.selecionada]="chave && escolhidos[chave] === g.rotulo" (click)="alterne(chave, g.rotulo)">
        <span class="barras__rotulo"><i [style.background]="g.cor" aria-hidden="true"></i>{{ g.rotulo }}</span>
        <span class="barras__valor num"><b>{{ g.total }}</b> {{ pct(g.total, leads.length) }}%</span>
        <span class="trilho"><span [style.width.%]="largura(g.total, grupos)" [style.background]="g.cor"></span></span>
      </button>
    </li>
  </ul>
</ng-template>

<!-- tabela de funil por grupo: sem colunas extras (nada de scroll lateral); % empilhada sob o número -->
<ng-template #tabelaFunil let-grupos="grupos" let-chave="chave">
  <table class="tabela-funil">
    <thead>
      <tr><th></th><th>Leads</th><th>Conversaram</th><th>Criaram teste</th><th>Clientes</th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let g of grupos; trackBy: porRotulo" [class.selecionada]="escolhidos[chave] === g.rotulo" (click)="alterne(chave, g.rotulo)"
          tabindex="0" (keydown.enter)="alterne(chave, g.rotulo)">
        <th scope="row"><i [style.background]="g.cor" aria-hidden="true"></i>{{ g.rotulo }}</th>
        <td class="num"><b>{{ g.total }}</b><small>{{ pct(g.total, leads.length) }}% do total</small></td>
        <td class="num"><b>{{ g.conversou }}</b><small>{{ pct(g.conversou, g.total) }}%</small></td>
        <td class="num"><b>{{ g.teste }}</b><small>{{ pct(g.teste, g.total) }}%</small></td>
        <td class="num"><b [class.verde]="g.cliente">{{ g.cliente }}</b><small>{{ pct(g.cliente, g.total) }}%</small></td>
      </tr>
    </tbody>
  </table>
</ng-template>
